/** Scatter display aliases → API/DB column keys (lowercase and mixed-case). */
const MANEUVER_CHANNEL_ALIASES: Record<string, readonly string[]> = {
  rake_aoa_min: ['rake_aoa_min_old_turn', 'Rake_aoa_min_old_turn'],
  rake_removed_time: ['rake_removed_old_time_turn', 'Rake_removed_old_time_turn'],
  rake_added_time: ['rake_added_new_time_turn', 'Rake_added_new_time_turn'],
};

/**
 * The underlying keys a display alias can be stored under, or null when the name is not an alias.
 *
 * For callers that look up a key rather than a row value — e.g. a baseline fit, which is keyed by
 * channel and has no row to probe.
 */
export function maneuverChannelAliasKeys(channel: string): readonly string[] | null {
  return MANEUVER_CHANNEL_ALIASES[String(channel).toLowerCase()] || null;
}

/** Resolve a scatter channel alias to a value from a maneuver row. */
export function resolveManeuverChannelAlias(
  row: Record<string, unknown>,
  channel: string
): unknown {
  const chLower = String(channel).toLowerCase();
  const aliasKeys = MANEUVER_CHANNEL_ALIASES[chLower];
  if (!aliasKeys) return undefined;

  for (const key of aliasKeys) {
    const val = row[key];
    if (val !== undefined && val !== null) return val;
  }
  return undefined;
}
